import React, { useState } from "react";
import googleLogo from "assets/images/google_logo.png";
import { ReactComponent as EyeOff } from "assets/icons/eye_off.svg";
import { ReactComponent as EyeOpen } from "assets/icons/eye_open.svg";
import useDialog from "hooks/useDialog";
import useAuth from "hooks/useAuth";
const Signup = ({ isSettings = false }) => {
  const {
    closeSignupDialog,
    openSigninDialog,
    openVerifyEmailDialog,
    openTrialWelcomeDialog,
  } = useDialog();

  const { signUp, loading, error, signInWithGoogle } = useAuth();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [privacyPolicy, setPrivacyPolicy] = useState(false);
  const [marketing, setMarketing] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await signUp(
        firstName.trim(),
        lastName.trim(),
        email.trim(),
        password.trim(),
        privacyPolicy,
        marketing
      );
      if (!error) {
        openVerifyEmailDialog(firstName, lastName, email);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      await signInWithGoogle(privacyPolicy, marketing, true);
      closeSignupDialog();
      openTrialWelcomeDialog();
    } catch (err) {
      console.error("Google login error", err);
    }
  };
  return (
    <form onSubmit={handleSubmit} className="">
      <h2 className="text-[20px] font-semibold leading-[28px] text-[#1A1A1A]">
        Iscriviti ad <span className="text-primary"> HouseScan</span>
      </h2>
      <div className=" mt-2 sm:mt-[24px]">
        <label className="text-[11px] font-normal text-[#333333] pl-4">
          Nome e Cognome
        </label>
        <div className="flex items-center space-x-2">
          <input
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            placeholder="Nome"
            className="auth-input"
          />
          <input
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            placeholder="Cognome"
            className="auth-input"
          />
        </div>
      </div>
      <div className="mt-[16px]">
        <label className="text-[11px] font-normal text-[#333333] pl-4">
          Email
        </label>
        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          className="auth-input"
        />
      </div>
      <div className="mt-4 relative">
        <label className="text-[11px] font-normal text-[#333333] pl-4">
          Password
        </label>
        <input
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          className="auth-input"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
        />
        <div
          onClick={() => setShowPassword((show) => !show)}
          className="absolute bottom-[2px] md:bottom-2 right-2 cursor-pointer w-[32px] h-[32px] flex items-center justify-center"
        >
          {showPassword ? (
            <EyeOpen width={16} height={16} />
          ) : (
            <EyeOff width={18} height={18} />
          )}
        </div>
      </div>
      <div className="w-full mt-[32px]">
        <div className="flex items-center space-x-2">
          <div>
            <input
              checked={privacyPolicy}
              onChange={(e) => setPrivacyPolicy(e.target.checked)}
              type="checkbox"
              name="switch"
              id={
                isSettings ? "switch_privacy_settings" : `switch_privacy_signup`
              }
              className="checkbox_input hidden"
            />
            <label
              className="checkbox_label"
              htmlFor={
                isSettings ? "switch_privacy_settings" : `switch_privacy_signup`
              }
            ></label>
          </div>

          <p className="text-[#1A1A1A] text-[12px] font-normal leading-5 tracking-[0.3px]">
            Accetto la{" "}
            <span
              onClick={() =>
                window.open(
                  "https://www.iubenda.com/privacy-policy/97520177",
                  "_blank"
                )
              }
              className="text-primary underline cursor-pointer"
            >
              Privacy Policy
            </span>{" "}
            di HouseScan
          </p>
        </div>
        <div className="flex items-center space-x-2 mt-2">
          <div>
            <input
              checked={marketing}
              onChange={(e) => setMarketing(e.target.checked)}
              type="checkbox"
              name="switch"
              id={
                isSettings
                  ? "switch_marketing_settings"
                  : `switch_marketing_signup`
              }
              className="checkbox_input hidden"
            />
            <label
              className="checkbox_label"
              htmlFor={
                isSettings
                  ? "switch_marketing_settings"
                  : `switch_marketing_signup`
              }
            ></label>
          </div>

          <p className="text-[#1A1A1A] text-[12px] font-normal leading-5 tracking-[0.3px]">
            Accetto di ricevere comunicazioni di marketing
          </p>
        </div>
      </div>
      <button type="submit" disabled={loading} className="auth-btn">
        Iscriviti
      </button>
      <hr className="bg-[#E5E5E5] h-[0.5px] w-full" />
      <div
        onClick={handleGoogleLogin}
        className="bg-[#333333] cursor-pointer h-[40px] hover:bg-opacity-80 transition-all duration-300 ease-in-out w-full mt-[32px] rounded-[6px] flex items-center justify-center space-x-2"
      >
        <img src={googleLogo} alt="logo" className="w-5 h-5" />
        <p className="text-[12px] font-normal leading-5 tracking-[0.3px] text-white">
          Iscritivi tramite Google{" "}
        </p>
      </div>
      <div className="mt-[24px] flex items-center space-x-2 justify-center">
        <p className="text-[12px] font-normal leading-5 tracking-[0.3px] text-[#1A1A1A]">
          Hai già un account?
        </p>
        <p
          onClick={() => {
            closeSignupDialog();
            openSigninDialog();
          }}
          className="cursor-pointer text-[12px] font-normal leading-5 tracking-[0.3px] text-primary"
        >
          Accedi
        </p>
      </div>
    </form>
  );
};

export default Signup;
